export enum MainToWorkerEvent {
  RUN = "run",
  INTERRUPT = "interrupt",
  PAUSE = "pause",
  RESUME = "resume",
  LOAD_FILE = "load-file",
  REGISTER_API = "register-api",
  PORT = "port",
  BUFFERS = "buffers",
  SET_TRACE_STEP = "set-trace-step",
  CLEAR_REPL_STATE = "clear-repl-state",
  SEND_CONTROL_EVENTS = "send-control-events",
  IS_INTERRUPTED = "is-interrupted",
  SETUP = "setup",
}

export enum WorkerToMainEvent {
  STDOUT = 'stdout',
  STDERR = 'stderr',
  RUN_STARTED = 'runstarted',
  FINISHED = 'finished',
  STDIN = 'stdin',
  API_CALL = 'api-call',
  PYODIDE_READY = 'pyodide-ready',
  INIT_CANVAS = 'initCanvas',
  STEP_API = 'step',
  HIGHLIGHT_LINE = 'highlight-line',
  RESET_OUTPUT = 'reset-output',
  PYODIDE_LOAD_ERROR = 'pyodide-load-error',
  API_LOAD_FINISHED = 'api-load-finished',
  GET_CONTROL_EVENTS = 'get-control-events',
  GET_IS_INTERRUPTED = 'is-interrupted',
  SEND_INTERRUPT_STEP_DATA = 'send-interrupt-step-data',
}

export enum CanvasAndWorkerEvent {
  PROVIDE_STEP_MAP = 'provide-step-map',
  REQUEST_STEP_MAP = 'request-step-map',
  PROVIDE_CANVAS_STATE = 'provide-canvas-state',
  REQUEST_CANVAS_STATE = 'request-canvas-state',
}

export enum MainToCanvasEvent {
  CANVAS = 'canvas',
  IMAGE_CACHE = 'image-cache',
  PORT = 'port',
  SWITCH_CANVAS = 'switch-canvas',
}
